// Module
var code = `<!-- ko with: \$data.questionTypeSelectorModel -->
<button type="button" data-bind="click: action, key2click, clickBubble: false, attr: { title: title, 'aria-label': title }" class="svc-element__question-type-selector">
  <sv-svg-icon class="svc-element__question-type-selector-icon" params="iconName: iconName, size: 'auto', title: title">
  </sv-svg-icon>
  <!-- ko if: \$parent.renderPopup -->
  <sv-popup params="model: popupModel"></sv-popup>
  <!-- /ko -->
</button>
<!-- /ko -->`;
// Exports
export default code;